<mat-card class="dm__card">
  <p8-layout-settings-header [titlePath]="[data?.listRequester?.name, titlePath()]"></p8-layout-settings-header>
  <mat-card-content>
    <mat-card-subtitle>

    </mat-card-subtitle>
    <!-- Ajout d'un membre à la liste -->
    <ng-container *ngIf="data?.action === 'add'">
      <span matBadge="1" matBadgePosition="before" matBadgeOverlap="false">Rechercher une personne dans l'annuaire LDAP (BIATS / enseignants-chercheurs)</span>
      <app-search-ldap
        [ldapDisplayProperty]="'cn,mail'"
        [removeDiatrics]="true"
        [mode]="'light'"
        [placeHolder]="'Recherche d\'une personne dans l\'annuaire LDAP P8 puis la sélectionner pour compléter ses informations'"
        [scope]="true"
        [title]="false"
        [defaultScopes]="'employee,faculty,researcher'"
        [scopesToDisplay]="['employee', 'faculty', 'researcher', 'student']"
        (ldapUserSelected)="onSelectIndiv($event)">
      </app-search-ldap>
      <mat-error *ngIf="allReadyExist">{{allReadyExist}}</mat-error>
      <div *ngIf="ldapUser && individuToAdd">
        <span matBadge="2" matBadgePosition="before" matBadgeOverlap="false">Veuillez saisir les informations complémentaires pour <strong>{{ldapUser.displayName}}</strong> le cas échéant :</span>
        <div>
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Informations utiles à renseigner pour {{ldapUser.displayName}} (fonction, UFR ou service, autre)</mat-label>
            <textarea [(ngModel)]="infoUser"
                      rows="3"
                      maxlength="250"
                      matInput
                      matTooltip="Informations utiles (fonction, UFR ou service, autre)"
                      placeholder="Informations utiles pour cette personne (fonction, UFR ou service, autre)"
                      type="text"></textarea>
            <mat-hint align="end"><code>{{infoUser?.length}}</code> / <code>{{250}}</code></mat-hint>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
    <!-- Modification des informations du membre -->
    <ng-container *ngIf="data?.action === 'edit'">
      <div>
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>Informations utiles à renseigner pour {{userName()}} (fonction, UFR ou service, autre)</mat-label>
          <textarea [(ngModel)]="infoUser"
                    rows="3"
                    maxlength="250"
                    matInput
                    matTooltip="Informations utiles (fonction, UFR ou service, autre)"
                    placeholder="Informations utiles pour cette personne (fonction, UFR ou service, autre)"
                    type="text"></textarea>
          <mat-hint align="end"><code>{{infoUser?.length}}</code> / <code>{{250}}</code></mat-hint>
        </mat-form-field>
      </div>
    </ng-container>
  </mat-card-content>
  <!-- actions bouttons -->
  <mat-dialog-actions align="end">
    <button (click)="dialogRef.close()"
            mat-raised-button
            color="accent"
            type="button">
      Annuler
    </button>
    <button mat-raised-button (click)="addOrUpdateMemberList()"
            [disabled]="infoUser?.length > 250 || saving"
            color="primary"
            aria-disabled="false"
            matTooltipPosition="right"
            matTooltip="{{buttonTooltip()}}">
      {{buttonTitle()}}
    </button>
  </mat-dialog-actions>
</mat-card>
